import type { UpdateLocalGiftCardRequest } from "common/models/api/models/UpdateLocalGiftCardRequest";
import { useToast } from "@commonlibs";
import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UpdateLocalGiftCardProps {
    id: number;
    payload: UpdateLocalGiftCardRequest;
}

export default function useUpdateLocalGiftCard({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, UpdateLocalGiftCardProps>): UseMutationResult<void, unknown, UpdateLocalGiftCardProps> {
    const translate = useTranslate();
    const { showToast } = useToast();
    const queryClient = useQueryClient();

    const handleOnSuccess = (data: void, variables: UpdateLocalGiftCardProps, context: unknown) => {
        showToast(translate("infoSavedSuccesfully"), { type: "success" });
        queryClient.invalidateQueries(Queries.GIFTCARDS_FIND_ALL);
        onSuccess?.(data, variables, context);
    };

    return useMutation(
        async ({ id, payload }: UpdateLocalGiftCardProps) => {
            await giftcardsApi.updateLocalGiftCard(id, payload);
        },
        {
            onSuccess: handleOnSuccess,
            ...options,
        },
    );
}
